import { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

import { authenticate, resendConfirmationCode } from 'cognito/auth';

const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const MIN_PASSWORD_LENGTH = 6;

function Login ( { onSuccess } )
{
    const { currentUser, onLoggedIn } = useContext ( CurrentUserContext );

    const navigate = useNavigate ();

    const [ email, setEmail ] = useState ( localStorage.getItem ( "email" ) ? localStorage.getItem ( "email" ) : "" );
    const [ password, setPassword ] = useState ( "" );
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    useEffect ( () => {
    
            if ( currentUser )
            {
                navigate ( '/' );
            }
    
        }, [ currentUser ] );

    const doSignIn = async () =>
    {
        localStorage.setItem ( "email", email );
        setError ( { isError: false, message: null } );
        setIsLoading ( true );

        try
        {
            const result = await authenticate ( email, password );
            console.log ( result );

            if ( result.nextStep.signInStep === "RESET_PASSWORD" )
            {
                navigate ( '/participant/passwordreset' );   
            }
            if ( result.nextStep.signInStep === "CONFIRM_SIGN_UP" )
            {
                resendConfirmationCode ( email );
                navigate ( '/participant/register/confirm' );
            }
            else
            {
                setError ( { isError: false, message: null } );
                setIsLoading ( false );

                onLoggedIn ();

                if ( !onSuccess )
                {
                    navigate ( '/' );
                }
                else
                {
                    onSuccess ();
                }
            }
        }
        catch ( error )
        {
            if ( error.name === "NotAuthorizedException" || error.name === "UserNotFoundException" )
            {
                setError ( { isError: true, message: "Invalid email or password" } )
            }
            else
            {
                setError ( { isError: true, message: JSON.stringify ( error ) } );
            }

            setIsLoading ( false );
        }
    }

    const isInputValid = () =>
    {
        return EMAIL_PATTERN.test ( email ) && password.length >= MIN_PASSWORD_LENGTH;
    }

    return  <div className="w-full sm:w-4/6 md:w-3/6 m-auto">
                <h1>Login</h1>
                <form>
                    { error.isError && <Error message={error.message} /> }
                    <LabelledInput id="email" label="Email" value={email} onChange={ ( newValue ) => setEmail ( newValue ) } type="email" />
                    <LabelledInput id="password" label="Password" value={password} onChange={ ( newValue ) => setPassword ( newValue ) } type="password" />
                    <div className="flex flex-row gap-8">
                        <button onClick={ () => doSignIn () } disabled={ !isInputValid () || isLoading } type="submit">Login</button>
                    </div>
                    <div className="flex flex-row gap-4 pt-4">
                        <Link className="m-0 inline-block" to="/participant/register">Register a New Account</Link>
                        <span className="text-pgdarkteal">|</span>
                        <Link className="m-0 inline-block" to="/participant/requestpasswordreset">Reset Password</Link>
                    </div>
                </form>
            </div>
}

export default Login;